module.exports = __webpack_public_path__ + "img/info_address.6ed2db14.svg";